module.exports = __webpack_public_path__ + "static/media/ecom-nega.64ac9283.svg";